<template>
    <v-card>
        <v-card-actions
                v-if="!editMode && canEditCard"
        >
            <v-dialog
                    v-model="dialogDelete"
                    max-width="500px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                            v-if="currentItem && currentItem.id"
                            color="red darken-1"
                            dark
                            x-small
                            class="mb-2"
                            v-bind="attrs"
                            v-on="on"
                    >
                        {{$vuetify.lang.t('$vuetify.page.action.btnDelete')}}
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title class="headline">{{$vuetify.lang.t('$vuetify.page.all.deleteMsg')}}
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">
                            {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm" :loading="axiosLoading">
                            {{$vuetify.lang.t('$vuetify.page.action.btnYes')}}
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-spacer/>
            <v-btn
                    color="blue darken-1"
                    dark
                    x-small
                    class="mb-2"
                    @click="editItem"
                    v-if="canEditCard"
            >
                {{$vuetify.lang.t('$vuetify.page.action.btnEdit')}}
            </v-btn>
        </v-card-actions>

        <v-card-text>
            <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    v-if="currentItem"
            >
                <v-container>
                    <v-row>
                        <v-col cols="4">
                            <div class="text-body-1">BIZ</div>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                    dense
                                    outlined
                                    :readonly="!editMode"
                                    :label="$vuetify.lang.t('$vuetify.page.ClientsCard.remote.login')"
                                    v-model="currentItem.biz.login"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                    dense
                                    outlined
                                    :readonly="!editMode"
                                    :label="$vuetify.lang.t('$vuetify.page.ClientsCard.remote.password')"
                                    v-model="currentItem.biz.password"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <div class="text-body-1">WEB</div>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                    dense
                                    outlined
                                    :readonly="!editMode"
                                    :label="$vuetify.lang.t('$vuetify.page.ClientsCard.remote.url')"
                                    v-model="currentItem.web.url"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <div class="text-body-1">API транспорт</div>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                    dense
                                    outlined
                                    :readonly="!editMode"
                                    :label="$vuetify.lang.t('$vuetify.page.ClientsCard.remote.key')"
                                    v-model="currentItem.api.key"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                    dense
                                    outlined
                                    :readonly="!editMode"
                                    :label="$vuetify.lang.t('$vuetify.page.ClientsCard.remote.password')"
                                    v-model="currentItem.api.password"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <div class="text-body-1">API delivery</div>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                    dense
                                    outlined
                                    :readonly="!editMode"
                                    :label="$vuetify.lang.t('$vuetify.page.ClientsCard.remote.login')"
                                    v-model="currentItem.apiDelivery.login"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                    dense
                                    outlined
                                    :readonly="!editMode"
                                    :label="$vuetify.lang.t('$vuetify.page.ClientsCard.remote.password')"
                                    v-model="currentItem.apiDelivery.password"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <div class="text-body-1">Delivery men</div>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                    dense
                                    outlined
                                    :readonly="!editMode"
                                    :label="$vuetify.lang.t('$vuetify.page.ClientsCard.remote.key')"
                                    v-model="currentItem.deliveryMen.key"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <div class="text-body-1">Портал</div>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                    dense
                                    outlined
                                    :readonly="!editMode"
                                    :label="$vuetify.lang.t('$vuetify.page.ClientsCard.remote.value')"
                                    v-model="currentItem.portal.description"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>

        <v-card-actions v-if="editMode">
            <v-btn
                    color="red darken-1"
                    text
                    @click="cancel"
            >
                {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                    color="blue darken-1"
                    text
                    @click="save"
                    :loading="axiosLoading" :disabled="!valid"
            >
                {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "ClientRemote",
        created() {
            this.$store.dispatch('retrieveClientRemote')
            this.$store.dispatch('retrieveClientServiceTypeDictionaryList')
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1
                    ? this.$vuetify.lang.t('$vuetify.page.action.formAddTitle', this.$vuetify.lang.t('$vuetify.page.ClientsCard.remote.crudName'))
                    : this.$vuetify.lang.t('$vuetify.page.action.formEditTitle', this.$vuetify.lang.t('$vuetify.page.ClientsCard.remote.crudName'))
            },
            currentItem() {
                return this.$store.getters.clientRemote
            },
            canEditCard() {
                return this.$store.getters.hasRole(['Administrator', 'ClientManager'])
            },
        },
        data() {
            return {
                currentCompanyDictionaryId: null,
                dialog: false,
                dialogDelete: false,
                valid: !this.formError,
                vue: this,
                editMode: false,
                editedIndex: -1,
            }
        },
        methods: {
            editItem() {
                this.editMode = true
            },
            deleteItem() {
                this.dialogDelete = true
            },
            deleteItemConfirm() {
                this.$store.dispatch('deleteClientRemote', this.currentItem.id).then(() => this.closeDelete())
            },
            close() {
                this.editMode = false
            },
            closeDelete() {
                this.dialogDelete = false
            },
            save() {
                if (this.$refs.form.validate()) {
                    if (!this.currentItem.id) {
                        this.currentItem.id = this.$uuid.v4()
                        this.currentItem.isUpdate = false
                    } else {
                        this.currentItem.isUpdate = true
                    }
                    this.$store.dispatch('setClientRemote', this.currentItem).then(() => this.close())
                }
            },
            cancel(){
                this.editMode = false
            },
        }
    }
</script>

<style scoped lang="scss">
    .v-data-table ::v-deep table td{
        font-size: 1rem !important;
    }
</style>